// extracted by mini-css-extract-plugin
module.exports = {"breakWord":"Styles_breakWord__37UEv"};